/**
 * 竞价出价记录详细
 */

import React from 'react';
import '../../../style/ui/visitorList.css'


class VisitorList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            countDown: {
                //倒计时
                hour: "00", //小时
                minute: "00", //分钟
                second: "00", //秒
                ms: "000", //毫秒
            },
            sessionSituation: {
                status: 0,
                statusStr: '',
                currentLotsIndex: 0
            }, // 当前场次状态
            showCountDown: false,
            localLotsIndex: 0, //当前显示的是第几个竞价品的信息，页面显示使用 
            lotsList: [],  //竞拍场次列表   
            sessionInfo: {},
            sessionId: '',
        };
    }


    detail = (index) => {
        this.props.detail(index);
    }
    render() {
        let sessionInfo = this.props.sessionInfo;
        let sessionSituation = this.props.sessionSituation;
        let countDown = this.props.countDown;
        let showCountDown = this.props.showCountDown;

        if (sessionInfo.lots !== null) {
            for (let i = 0; i < sessionInfo.lots.length; i++) {
                if (sessionInfo.lots[i].status === 0) {
                    sessionInfo.lots[i].statusResult = '无人出价'
                } else if (sessionInfo.lots[i].status === 1) {
                    sessionInfo.lots[i].statusResult = '已成交'
                } else if (sessionInfo.lots[i].status === 2) {
                    sessionInfo.lots[i].statusResult = '低于保留价 '
                }
            }
        }

        let htmlStr = ''
        htmlStr = (
            <div className="visitorList">

                <div className="session-header">
                    <div className="session-headerbox">
                        <div className="header-content">
                            <div className="name">{sessionInfo.name}</div>
                            {
                                (showCountDown && sessionSituation.status === 0) ? <div className="timebox" >
                                    <div className="countDownTime">
                                        <div className="group">{countDown.hour}</div>
                                        <div className="maohao">:</div>
                                        <div className="group">{countDown.minute}</div>
                                        <div className="maohao">:</div>
                                        <div className="group">{countDown.second}</div>
                                        <div className="maohao">.</div>
                                        <div className="msgroup">{countDown.ms}</div>
                                    </div>
                                </div> : ''
                            }
                            {
                                sessionSituation.status === 1 || (!showCountDown && sessionSituation.status) === 0 ? <div className="time" >{sessionInfo.startTime}</div> : ""
                            }
                            {
                                sessionSituation.status === 2 ? <div className="time">{sessionInfo.endTime}</div> : ""
                            }
                            <div className="viewAddr">看车地点：{sessionInfo.viewAddr}</div>
                        </div>
                    </div>
                </div>
                <div className="sessionList">
                    <div className="allBidding">本场竞价品<span>({sessionInfo.lotsNum})</span>个</div>
                    <div className="flex">
                        <div className="total-parent">
                            <div className="total-label"></div>
                            <div className="total"></div>
                            <div className="total-label"></div>
                        </div>
                    </div>
                    {
                        sessionInfo.lots.map((item, index) => {
                            return <div className="car-list" key={index} onClick={this.detail.bind(this, index)}>
                                <div className="block-7" >
                                    <div className="product-wrap fl">
                                        <img src={item.vehicleImageThumbnail} className="product" alt="" />
                                    </div>
                                    <div className="container-1 fl">
                                        <span className="title-1">{item.name}</span>
                                        <div className="container-2">
                                            <div className="milage"><span className="txt1">{item.registerDate}</span>/<span className="txt2">{item.mileage}公里</span></div>
                                        </div>
                                        {/* <div className="container-2">
                                       <div className="wrap-1">
                                           <span  className="num-4"></span>
                                            <span  className="word-6"><span className="red">{item.bidTimes?item.bidTimes:'0'}</span>人出价</span>
                                       </div>
                                   </div> */}
                                        <div className="outer-1">
                                            {item.status === 1 || item.status === 3 ? <div className="money-wrap" >
                                                <span className="money-label">最终价:</span>
                                                <span className="money">￥{item.finalPriceStr}元</span>
                                            </div> : <div className="money-wrap" >
                                                <span className="money-label">起始价:</span>
                                                <span className="money">￥{item.startPriceStr}元</span>
                                            </div>}
                                        </div>
                                        <div className="button-wrap-2" >
                                            {sessionSituation.status === 1 ? (index < sessionSituation.currentLotsIndex ?
                                                <div className="failBtn" >已结束</div> :
                                                (index === sessionSituation.currentLotsIndex ? <div className="successBtn">进行中</div> :
                                                    <div className="failBtn" >未开始</div>)) : ''}
                                            {sessionSituation.status === 2 || sessionSituation.status === 3 ? (item.status !== null ?
                                                <div className="failBtn" >{item.statusResult}</div> : <div className="failBtn" >{item.statusResult}</div>) : ''}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        })
                    }

                </div>
            </div>
        )
        return htmlStr
    }

}

export default VisitorList;